"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 01/03/2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var SupplierPriceRecalculationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierPriceRecalculationConverter, _DataObjectConverter_);

  function SupplierPriceRecalculationConverter() {
    _classCallCheck(this, SupplierPriceRecalculationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierPriceRecalculationConverter).apply(this, arguments));
  }

  return SupplierPriceRecalculationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierPriceRecalculationConverter = SupplierPriceRecalculationConverter;